const mainSurveyInitState = JSON.parse(localStorage.getItem('currentMainSurvey'))
const userSurveyInitState = JSON.parse(localStorage.getItem('currentUserSurvey'))
const userQuestionListInitState = JSON.parse(localStorage.getItem('currentUserQuestionList'))


export const survey = {
  namespaced: true,
  state: {
    currentMainSurvey : mainSurveyInitState,
    currentUserSurvey : userSurveyInitState,
    currentUserQuestionList : userQuestionListInitState,
  },
  actions: {
    updateCurrentMainSurvey({commit}, payload){
      commit('mutateCurrentMainSurvey', payload)
    },
    updateCurrentUserSurvey({commit}, payload){
      commit('mutateCurrentUserSurvey', payload)
    },
    updateCurrentUserQuestionList({commit}, payload){
      commit('mutateCurrentUserQuestionList', payload)
    },
  },
  mutations: {
    mutateCurrentMainSurvey(state, payLoad){
      localStorage.setItem("currentMainSurvey", JSON.stringify(payLoad))
      state.currentMainSurvey = payLoad
    },
    mutateCurrentUserSurvey(state, payLoad){
      localStorage.setItem("currentUserSurvey", JSON.stringify(payLoad))
      state.currentUserSurvey = payLoad
    },
    mutateCurrentUserQuestionList(state, payLoad){
      localStorage.setItem("currentUserQuestionList", JSON.stringify(payLoad))
      state.currentUserQuestionList = payLoad
    },
  },

};
